<div
  class="flex max-w-6xl flex-1 flex-col gap-2 rounded-t-lg bg-[#fafafa] px-8 pb-8 pt-4 md:m-4 md:rounded-b-lg"
>
  <div class="mb-2 flex items-center gap-8">
    <a [routerLink]="['/']">
      <img
        class="h-[40px]"
        src="/assets/icons/principle-logo.svg"
        alt="Principle Partner Portal"
        onerror="this.src='/assets/icons/principle-logo.png'"
      />
    </a>

    <div class="flex flex-col items-start">
      <span class="text-lg">Principle Partner Portal</span>
      <pt-breadcrumbs
        class="!p-0"
        [breadcrumbs]="breadcrumbs.breadcrumbs$ | async"
      />
    </div>

    <div class="flex-1"></div>

    <div class="flex items-center gap-2">
      <pr-partner-toolbar-dropdown />

      <button
        mat-mini-fab
        class="!min-h-[40px]"
        id="intercom-launcher"
        aria-label="Customer Support Button"
        matTooltip="Customer Support"
      >
        <mat-icon class="intercom-icon">question_answer</mat-icon>
      </button>
    </div>
  </div>

  <router-outlet />
</div>

<hotkeys-cheatsheet />
